"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemForm = require("@/api/systemForm");
var _public = require("@/libs/public");
var _useProduct2 = require("@/hooks/use-product");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
var _default = exports.default = {
  name: 'systemFormIndex',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:system:form:page'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _systemForm.systemFormPageApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.$store.commit('mobildConfig/SET_SystemForm', res.list);
        localStorage.setItem('systemFormList', JSON.stringify(res.list));
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
        _this.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //删除
    handlerDelete: function handlerDelete(id) {
      var _this2 = this;
      this.$modalSure('确定要删除此表单吗？').then(function () {
        (0, _systemForm.systemFormDeleteApi)(id).then(function (res) {
          _this2.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this2.tableData.data.length, _this2.tableFrom);
          _this2.$store.commit('mobildConfig/SET_SystemForm', []);
          _this2.getList();
        });
      });
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    }
  }
};